import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import BookingWizard from "@/pages/BookingWizard";
import BookingSuccess from "@/pages/BookingSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Impressum from "@/pages/Impressum";
import { LanguageProvider } from "@/lib/i18n";
import "@/App.css";

function App() {
  return (
    <div className="App min-h-screen bg-[#09090B] text-[#FAFAFA]">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/buchen" element={<BookingWizard />} />
            <Route path="/buchung-erfolgreich/:reference" element={<BookingSuccess />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/impressum" element={<Impressum />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </LanguageProvider>
    </div>
  );
}

export default App;
